// Centralized form options configuration
// Update these arrays to modify options across all components

export const OCCASION_OPTIONS = [
  'Anniversary',
  'Birthday',
  'Holiday',
  // 'Christmas',
  // 'Hanukkah',
  "Valentine's Day",
  "Mother's Day",
  'Special Trip',
  // 'Special celebration',
  // 'New year',
  // 'Wedding',
  'Other',
];

export const RELATIONSHIP_OPTIONS = ['Wife', 'Husband', 'Daughter', 'Son', 'Mother', 'Father', 'Friend', 'Other'];

export const SIZE_OPTIONS = {
  TOPS: [
    'XS',
    'S',
    'M',
    'L',
    'XL',
    'XXL',
    '0–3 Months',
    '3–6 Months',
    '6–9 Months',
    '9–12 Months',
    '12–18 Months',
    '18–24 Months',
    '2T',
    '3T',
    '4T',
    '5T',
    'Kids XS',
    'Kids S',
    'Kids M',
    'Kids L',
  ],
  BOTTOMS: [
    'XS',
    'S',
    'M',
    'L',
    'XL',
    'XXL',
    '0-3 Months',
    '3–6 Months',
    '6–9 Months',
    '9–12 Months',
    '12–18 Months',
    '18–24 Months',
    '2T',
    '3T',
    '4T',
    '5T',
    'Kids XS',
    'Kids S',
    'Kids M',
    'Kids L',
  ],
  SHOES: [
    '5',
    '5.5',
    '6',
    '6.5',
    '7.5',
    '7',
    '8',
    '8.5',
    '9',
    '9.5',
    '10',
    '10.5',
    '11',
    '11.5',
    '12',
    '12.5',
    '13',
    '13.5',
    '14',
    '14.5',
    '15',
    'Infant 0',
    'Infant 1',
    'Infant 2',
    'Infant 3',
    'Toddler 4',
    'Toddler 5',
    'Toddler 6',
    'Toddler 7',
    'Toddler 8',
    'Toddler 9',
    'Toddler 10',
    'Kids 11',
    'Kids 12',
    'Kids 13',
    'Kids 1',
    'Kids 2',
    'Kids 3',
    'Kids 4',
    'Kids 5',
    'Kids 6',
    'Kids 7',
  ],
};

export const MAX_RECIPIENTS = 3; // Maximum recipients for one-off flow

// Occasions that should only be selected once per subscription
// Add/remove occasions from this list to control duplicate prevention
export const UNIQUE_OCCASIONS = ["Mother's Day", "Valentine's Day"];
